/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Catalog_Movement_PushInputs */

const en_us2_catalog_movement_push = /** @type {(inputs: Catalog_Movement_PushInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Push`)
};

const pt_br2_catalog_movement_push = /** @type {(inputs: Catalog_Movement_PushInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empurrar`)
};

const es_419_catalog_movement_push = /** @type {(inputs: Catalog_Movement_PushInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empujar`)
};

const pt_pt2_catalog_movement_push = /** @type {(inputs: Catalog_Movement_PushInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empurrar`)
};

const fr_fr2_catalog_movement_push = /** @type {(inputs: Catalog_Movement_PushInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poussée`)
};

const de_de2_catalog_movement_push = /** @type {(inputs: Catalog_Movement_PushInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drücken`)
};

const it_it2_catalog_movement_push = /** @type {(inputs: Catalog_Movement_PushInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spinta`)
};

/**
* | output |
* | --- |
* | "Push" |
*
* @param {Catalog_Movement_PushInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const catalog_movement_push = /** @type {((inputs?: Catalog_Movement_PushInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Catalog_Movement_PushInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_catalog_movement_push(inputs)
	if (locale === "es-419") return es_419_catalog_movement_push(inputs)
	if (locale === "pt-PT") return pt_pt2_catalog_movement_push(inputs)
	if (locale === "fr-FR") return fr_fr2_catalog_movement_push(inputs)
	if (locale === "de-DE") return de_de2_catalog_movement_push(inputs)
	if (locale === "it-IT") return it_it2_catalog_movement_push(inputs)
	return en_us2_catalog_movement_push(inputs)
});
export { catalog_movement_push as "catalog.movement.push" }